const applicationConfig = {
    clientID: '37a357c8-8928-4a11-b53a-6b91001d81f7',
    scopes: ['https://graph.microsoft.com/user.read', 'https://graph.microsoft.com/user.readbasic.all'],
    authority: "https://login.microsoftonline.com/a63249ac-3e0b-4a24-9e0c-c90ab9891e30",
    redirectUri: 'http://localhost:3000/dashboard',
	postLogoutRedirectUri: 'https://localhost:3000',
};

let userAgentApplication;
const Msal = window.Msal;

var id_token_global = null
var access_token_global = null

const initializeMsal = () => {
    userAgentApplication = new Msal.UserAgentApplication(applicationConfig.clientID, applicationConfig.authority, applicationConfig.redirectUri, applicationConfig.postLogoutRedirectUri, function (errorDes, token, error, tokenType, instance) {
        if (error) console.log(error + ": " + errorDes);
        else console.log("Token type = " + tokenType);
    });
};

initializeMsal();

export const MsalLogin = async () => {
    return new Promise((resolve, reject) => {
        userAgentApplication.loginPopup(applicationConfig.scopes).then(function (id_token) {
            var user = userAgentApplication.getUser();
    
            if (user) {
                id_token_global = id_token;
    
                userAgentApplication.acquireTokenSilent(applicationConfig.scopes).then(function (access_token) {
                    access_token_global = access_token;

                    return resolve({
                        name: user.name,
                        email: user.displayableId,
                        access_token_global,
                        id_token_global
                    });
    
                }, function (error) {
                    if (error.indexOf("interaction_required" != -1)) {
                        userAgentApplication.acquireTokenPopup(applicationConfig.scopes).then(function (access_token) {
                            access_token_global = access_token;

                            return resolve({
                                name: user.name,
                                email: user.displayableId,
                                access_token_global,
                                id_token_global
                            });
     
                        }, function (error) {
                            console.log("Failure acquiring token: " + error);
                            document.getElementById("sign_in_text").innerText = error;
                        });
                    }
                });
               
            } else {
                console.log("signed in failure");
                return reject("signed in failure")
            }
        }, function (error) {
            console.log("error: " + error);
            return reject(error)
        });
    });
};

// module.exports = {
//     initializeMsal,
//     MsalLogin
// }